import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { ErrorResponse, httpClient } from '@/api/http-client'

type DeleteDealUserParams = {
  deal_key: string
  user_key: string
}

export async function deleteDealUser({
  deal_key,
  user_key,
}: DeleteDealUserParams) {
  const response = await httpClient('accounting-dealer').delete(
    `/v3/deal/${deal_key}/user`,
    {
      data: {
        user_key,
      },
    },
  )

  return response.data
}

export function useDeleteDealUser(
  options?: UseMutationOptions<unknown, ErrorResponse, DeleteDealUserParams>,
) {
  return useMutation({
    mutationFn: deleteDealUser,
    ...options,
  })
}
